import { isNonEmptyString } from '../../../utils/checks'

export const shouldShowPriceTooltip = (price_label) =>
  isNonEmptyString(price_label)
